// src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

// Create an Axios instance
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Add a request interceptor to include the token in every request
api.interceptors.request.use(async (config) => {
  // Attach the token to the request headers if it exists
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


// Add a response interceptor to handle token refresh or logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized errors (e.g., logout the user)
      localStorage.removeItem('token');
      localStorage.removeItem('zoom_token'); // Clear zoom token as well
      window.location.href = '/login'; // Redirect to login page
    }
    return Promise.reject(error);
  }
);

// Login function
export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });

  // Save the token to localStorage
  localStorage.setItem('token', response.data.token);

  return response.data;
};

// Register function
export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);

  // Save the token to localStorage
  // localStorage.setItem('token', response.data.token);

  return response.data;
};

// Verify email function
export const verifyEmail = async (otp, email) => {
  const response = await api.post('/auth/verify-email', { otp, email });
  return response.data; // Ensure this includes user data (e.g., role_id, token)
};

// Complete registration function
export const completeRegistration = async (tempUserId, age) => {
  const response = await api.post('/auth/complete-registration', { tempUserId, age });

  // Save the token to localStorage
  localStorage.setItem('token', response.data.token);

  return response.data;
};

// Get user profile function
export const getProfile = async (token) => {
  const response = await api.get('/user');
  return response.data;
};

// Logout function
export const logout = async () => {
  const response = await api.post('/auth/logout');

  // Remove the token from localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('zoom_token'); 

  return response.data;
};

// Get wallet balance function
export const getWalletBalance = async () => {
  const response = await api.get('/student/wallet');
  return response.data; // Assuming the API returns { amount: 1000 }
};

// Recharge wallet function
export const rechargeWallet = async (amount) => {
  const response = await api.post('/student/wallet/deposit', { amount });
  return response.data; // Assuming the API returns { newBalance: 1500 }
};

export default api;